<template>
    <v-simple-table>
        <template v-slot:default>
            <thead>
                <tr>
                    <th class="text-left">
                        Analysis Date
                    </th>
                    <th class="text-left">
                        Comments
                    </th>
                    <th class="text-left">
                        Attachment
                    </th>
                </tr>
            </thead>
            <tbody>
                <template v-for="(item, index) in venomAnalysis">
                    <tr :key="item.VenomAnalysisID + 'a'" :class="'clear-bottom-border' + (index % 2 == 0 ? ' highlight-row' : '')">
                        <td>{{ $moment.utc(item.AnalysisDate).format($constants.DATE_FORMAT_NO_TIME) }}</td>
                        <td>{{ item.OtherComments }}</td>
                        <td>{{ item.S3Path ? "Yes" : "No" }}</td>
                    </tr>
                    <tr :key="item.VenomAnalysisID + 'b'" :class="(index % 2 == 0 ? 'highlight-row' : '')">
                        <td colspan="3" v-if="item.Proteins.length > 0">
                            <v-row v-for="pro in item.Proteins" :key="pro.VenomAnalysisProteinID" no-gutters>
                                <v-col cols="6">
                                    <span class="font-weight-bold">Protein:</span> {{pro.Name}}
                                </v-col>
                                <v-col cols="6">
                                    <span class="font-weight-bold">Area %:</span> {{pro.LowRange}} - {{pro.HighRange}}
                                </v-col>
                                <v-col cols="12">
                                    <span class="font-weight-bold">Comments:</span>
                                    <p>{{pro.Comments}}</p>
                                </v-col>
                            </v-row>
                        </td>
                        <td colspan="3" v-else>
                            <span class="font-weight-bold">No proteins recorded</span>
                        </td>
                    </tr>
                </template>
                <template v-if="venomAnalysis.length == 0">
                    <td colspan="3" class="text-center">
                        There are no venom analysis recorded
                    </td>
                </template>
            </tbody>
        </template>
    </v-simple-table>
</template>

<script>
export default {
    props: {
        venomAnalysis: {
            type: Array,
            default: null
        }
    },
}
</script>

<style scoped>
tr.clear-bottom-border td {
    border-bottom: none !important;
}

tr.highlight-row {
    background-color: rgb(233, 222, 222) !important
}
</style>